import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import ScrollToTop from './ScrollToTop';
import NavBar from './components/Navbar/NavBar';
import Home from './pages/Home';
import Footer from './components/Footer/Footer';
import About from './pages/About';
import Gallery from './pages/Gallery';
import GalleryUpdated from './components/updated-gallery/gallery-updated';
import Releases from './pages/Releases';
import Programs from './pages/Programs';
import Program from './pages/Program';
import Team from './pages/Team';
import Contact from './pages/Contact';
import ComingSoon from './pages/ComingSoon';
import WomenMeetNavBar from './components/WomenFacultyMeet/navbar/navbar';
import {SVGs, PNG} from './utils/images';
import WomenAbout from './pages/WomenFacultyMeet/about/about';
import WomenCommittee from './pages/WomenFacultyMeet/committee/committee';
import WomenSpeakers from './pages/WomenFacultyMeet/speakers/speakers';
import WomenMeeting from './pages/WomenFacultyMeet/meeting/meeting';
import WomenContact from './pages/WomenFacultyMeet/contact/contact';
import { GiWomanElfFace } from 'react-icons/gi';

// import WomenMeet from './components/WomenMeet/WomenMeet';

function App() {
  const [title, setTitle] = React.useState('Academic Outreach and New Initiatives | IIT Delhi');
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <BrowserRouter>
      <div className="wrapper">
        <LoadingBar
          color='#C21717'
          progress={progress}
          onLoaderFinished={() => setProgress(0)}
        />
        <ScrollToTop />
        
        <Routes>
          {/* Women Faculty Meet routes without main NavBar and Footer */}
          {/* <Route path="/womenmeet" element={<WomenMeet />} /> */}

          <Route
            path="/womenmeet/*"
            element={
              <>
                <WomenMeetNavBar SVGs={SVGs}/>
                <Routes>
                  <Route path="/" element={<WomenAbout PNG={PNG} />} />
                  <Route path="/committee" element={<WomenCommittee PNG={PNG} />} />
                  <Route path="/speakers" element={<WomenSpeakers PNG={PNG} />} />
                  <Route path="/meeting" element={<WomenMeeting PNG={PNG} />} />
                  <Route path="/contact" element={<WomenContact PNG={PNG} />} />
                </Routes>
              </>
            }
          />
          
          {/* All other routes with main NavBar and Footer */}
          <Route path="*" element={
            <>
              <NavBar setTitle={setTitle} setProgress={setProgress} />
              <div className="content">
                <Routes>
                  <Route path="/" element={<Home setProgress={setProgress} setTitle={setTitle} />} />
                  <Route path="/about" element={<About setProgress={setProgress} setTitle={setTitle} />} />
                  <Route path="/programs" element={<Programs setProgress={setProgress} setTitle={setTitle} />} />
                  <Route path="/programs/*" element={<Program setProgress={setProgress} setTitle={setTitle} />} />
                  <Route path="/releases" element={<Navigate to="/releases/podcasts" />} />
                  <Route path="/releases/podcasts" element={<Releases setProgress={setProgress} setTitle={setTitle} activeItem={0} />} />
                  <Route path="/releases/glimpses" element={<Releases setProgress={setProgress} setTitle={setTitle} activeItem={1} />} />
                  <Route path="/releases/newsletters" element={<Releases setProgress={setProgress} setTitle={setTitle} activeItem={2} />} />
                  <Route path="/gallery" element={<GalleryUpdated setProgress={setProgress} setTitle={setTitle} />} />
                  <Route path="/team" element={<Team setProgress={setProgress} setTitle={setTitle} />} />
                  <Route path="/contact" element={<Contact setProgress={setProgress} setTitle={setTitle} />} />
                  <Route path="/experienceiitd" element={<ComingSoon setProgress={setProgress} setTitle={setTitle} />} />
                </Routes>
              </div>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;